import {Component, EventEmitter, Input, Output} from '@angular/core';
@Component({
  selector: 'app-partner-upgrade-offer-sent',
  templateUrl: './partner-upgrade-offer-sent.component.html'
})
export class PartnerUpgradeOfferSentComponent {
  @Input() customerEmail: string;
  @Output() next = new EventEmitter();
}
